import { defineStore } from "pinia";

export const DomainContactState = defineStore("DomainContactState", {
    state: () => ({
        searchTerm: null,
    }),
    actions() {
        
    }
});